import Header from '../../components/feature/Header';
import Hero from '../../components/feature/Hero';
import SearchSection from '../../components/feature/SearchSection';
import RecommendedSection from '../../components/feature/RecommendedSection';
import ListingsSection from '../../components/feature/ListingsSection';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <SearchSection />
      <RecommendedSection />
      <ListingsSection />
      <Footer />
    </div>
  );
}